import type React from "react";
import { useId } from "react";
import { getColor, type Props } from "~/components/icons/helper";

export const AccountIcon: React.FC<Props> = ({ color }) => {
	const id = useId();

	return (
		<svg
			role="img"
			aria-label="Account"
			width="30"
			height="30"
			viewBox="0 0 30 30"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath={`url(#${id})`}>
				<path
					d="M15 15.0003C18.9993 15.0003 22.2414 11.7583 22.2414 7.75896C22.2414 3.75965 18.9993 0.517578 15 0.517578C11.0007 0.517578 7.75862 3.75965 7.75862 7.75896C7.75862 11.7583 11.0007 15.0003 15 15.0003Z"
					stroke={getColor(color)}
					strokeMiterlimit="10"
					strokeLinecap="round"
				/>
				<path
					d="M0.517246 29.4826V26.0171C0.517246 23.8222 1.38916 21.7172 2.94118 20.1652C4.49321 18.6131 6.59821 17.7412 8.79311 17.7412H21.2069C23.4018 17.7412 25.5068 18.6131 27.0588 20.1652C28.6108 21.7172 29.4828 23.8222 29.4828 26.0171V29.4826"
					stroke={getColor(color)}
					strokeMiterlimit="10"
					strokeLinecap="round"
				/>
			</g>
			<defs>
				<clipPath id={id}>
					<rect width="30" height="30" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
